import { useState } from 'react';

import { Box, Flex } from '@chakra-ui/react';
import { useQueryClient } from '@tanstack/react-query';
import { putFeaturesAPI } from 'Deer/hooks/dataHooks/featureManagement/usePutFeatureManagementData';

import { ListItemComp } from 'uiToolkitV1/ListItemComp';
import { Switch } from 'uiToolkitV1/ToggleSwitch';
import { Tooltip } from 'uiToolkitV1/Tooltip';

type ModuleItemsProps = {
  heading: string;
  description: string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  moduleState?: 'DISABLED' | 'ENABLED' | 'NOT_SUPPORTED';
  isToggleAble: boolean;
  onToggle: (newState: boolean) => void;
  tooltipMessage?: string;
  moduleKey?: string;
};

export const ModuleItems = ({
  heading,
  description,
  icon: Icon,
  moduleState,
  isToggleAble,
  onToggle,
  tooltipMessage,
  moduleKey,
}: ModuleItemsProps) => {
  const [isEditable, setIsEditable] = useState(moduleState === 'ENABLED');
  const queryClient = useQueryClient();

  const toggleHandler = async () => {
    if (isToggleAble) {
      const newState = !isEditable;
      const status = newState ? 'ENABLED' : 'DISABLED';
      try {
        await putFeaturesAPI({ type: moduleKey, status });
        queryClient.invalidateQueries(['loggedInUsersAccesses']);
        setIsEditable(newState);
        onToggle(newState);
      } catch (error) {
        console.error('Error updating feature status:', error);
      }
    }
  };

  return (
    <Box w="100%" h="100%" ml="4px">
      {moduleState !== 'NOT_SUPPORTED' ? (
        <Flex h="60px" justifyContent="space-between" alignItems="center">
          <ListItemComp
            isDisabled={!moduleState}
            isBoldText={false}
            withoutBackground
            title={heading}
            subTitle={description}
            // eslint-disable-next-line react/no-unstable-nested-components
            LeftComponent={() => <Icon color="#666666" />}
          />
          <Tooltip label={tooltipMessage} shouldWrapChildren isDisabled={!tooltipMessage}>
            <Switch isChecked={isEditable} onChange={toggleHandler} isDisabled={!isToggleAble} />
          </Tooltip>
        </Flex>
      ) : (
        <Box>
          <Tooltip label="Not included in current plan. Contact sales@mesh.ai" shouldWrapChildren>
            <ListItemComp
              isBoldText={false}
              isDisabled
              withoutBackground
              title={heading}
              subTitle={description}
              // eslint-disable-next-line react/no-unstable-nested-components
              LeftComponent={() => <Icon color="#666666" />}
            />
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};
